import { ANY_WHITESPACE_REGEX } from '../../constants/regex';

export default function sanitizeZip(zip: string | null): string {
  if (!zip) return null;
  return zip.replace(ANY_WHITESPACE_REGEX, '').toUpperCase();
}
